import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "overflow-y-scroll h-full" }
const _hoisted_2 = { class: "flex flex-col items-center justify-center p-2 md:p-4 min-h-full" }
const _hoisted_3 = { class: "flex flex-col bg-white shadow-xl p-3 md:p-20 transform transition-all my-auto sm:align-middle sm:max-w-2xl md:max-w-5xl w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "modal",
        class: _normalizeClass(["fixed z-20 inset-0 drop-shadow-3xl transition-opacity", {'bg-gray-500 bg-opacity-70': _ctx.backdrop}]),
        tabindex: "-1",
        onKeydown: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["esc"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "outside_top"),
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "content", {}, () => [
                _renderSlot(_ctx.$slots, "header"),
                _renderSlot(_ctx.$slots, "main"),
                _renderSlot(_ctx.$slots, "footer")
              ])
            ])
          ])
        ])
      ], 34))
    : _createCommentVNode("", true)
}